export class Boxes {
    content :string;
    weight :number = 0;
    excWeight: number = 0;
    calWeight :number = 0;
    length :number = 0;
    width :number = 0;
    height :number = 0;
    shipmentId :number;
    packTypeId :number;
    id :number;
    code :string;
    name :string;
    woodWeight: number = 0;
}